export const sportListData = [
  {
    key: "1",
    year: "2004",
    coachName: "Thomas",
    id: "SP826329",
    name: "Francis",
    img: "https://imageplaceholder.net/300",
    img2: "https://imageplaceholder.net/300",
    sports: "Cricket",
    dateofJoin: "25 Apr 2024",
  },
  {
    key: "2",
    year: "2005",
    coachName: "Georgia",
    id: "SP826328",
    name: "Cheryl",
    img: "https://imageplaceholder.net/300",
    img2: "https://imageplaceholder.net/300",
    sports: "Throwball",
    dateofJoin: "28 Apr 2024",
  },
  {
    key: "3",
    year: "2006",
    coachName: "Nicholas",
    id: "SP826327",
    name: "Daniel",
    img: "https://imageplaceholder.net/300",
    img2: "https://imageplaceholder.net/300",
    sports: "Football",
    dateofJoin: "04 May 2024",
  },
  {
    key: "4",
    year: "2006",
    coachName: "Sandra",
    id: "SP826326",
    name: "Irene",
    img: "https://imageplaceholder.net/300",
    img2: "https://imageplaceholder.net/300",
    sports: "Tennis",
    dateofJoin: "16 May 2024",
  },
  {
    key: "5",
    year: "2007",
    coachName: "Jon",
    id: "SP826325",
    name: "Keith",
    img: "https://imageplaceholder.net/300",
    img2: "https://imageplaceholder.net/300",
    sports: "Basketball",
    dateofJoin: "20 May 2024",
  },
  {
    key: "6",
    year: "2008",
    coachName: "Shannon",
    id: "SP826324",
    name: "Dina",
    img: "https://imageplaceholder.net/300",
    img2: "https://imageplaceholder.net/300",
    sports: "Badminton",
    dateofJoin: "12 Jun 2024",
  },
  {
    key: "7",
    year: "2009",
    coachName: "Wilson",
    id: "SP826323",
    name: "Michael",
    img: "https://imageplaceholder.net/300",
    img2: "assets/img/coach/coach-07.jpg",
    sports: "Carrom",
    dateofJoin: "17 Jun 2024",
  },
  {
    key: "8",
    year: "2004",
    coachName: "Sonia",
    id: "SP826322",
    name: "Julia",
    img: "https://imageplaceholder.net/300",
    img2: "assets/img/coach/coach-08.jpg",
    sports: "Chess",
    dateofJoin: "27 Jun 2024",
  },
  {
    key: "9",
    year: "2005",
    coachName: "Adams",
    id: "SP826321",
    name: "Ray",
    img: "https://imageplaceholder.net/300",
    img2: "assets/img/coach/coach-09.jpg",
    sports: "Hockey",
    dateofJoin: "10 Jul 2024",
  },
  {
    key: "10",
    year: "2008",
    coachName: "Lydia",
    id: "SP826320",
    name: "Lois",
    img: "https://imageplaceholder.net/300",
    img2: "https://imageplaceholder.net/300",
    sports: "Volleyball",
    dateofJoin: "20 Jul 2024",
  },
];
